import React, { useState, useEffect } from "react";
import { 
  FaArrowLeft, FaTrophy, FaSchool, FaAward, FaClipboardList, 
  FaHeart, FaBullhorn, FaWhatsapp, FaInstagram, FaFacebook 
} from "react-icons/fa";
import ICTSocietyForm from "./ICTSocietyForm";
import "./ICTSocietyPage.css";

export default function ICTSocietyPage({ onBack }) {
  const [showForm, setShowForm] = useState(false);

  // Prevent background scroll when form is open
  useEffect(() => {
    if (showForm) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showForm]);

  return (
    <div className="ict-society-page">
      <div className="ict-society-header">
        <button
          className="back-button"
          onClick={onBack}
          aria-label="Go back"
        >
          <FaArrowLeft />
        </button>
        <h1 className="ict-society-title">
          <FaTrophy className="title-icon" />
          Most Popular ICT Society
        </h1>
      </div>

      <div className="ict-society-content">
        <div className="hero-section">
          <div className="hero-badge">
            <FaAward className="badge-icon" />
            <span>Special Competition</span>
          </div>
          <p className="hero-description">
            Compete for the title of Sri Lanka's Most Popular ICT Society. 
            Showcase your society's innovation, impact, and excellence in technology education.
          </p>
        </div>

        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">
              <FaSchool />
            </div>
            <h3>Eligibility</h3>
            <p>
              Open to all ICT societies from schools across Sri Lanka. 
              Only one registration per school is allowed.
            </p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <FaClipboardList />
            </div>
            <h3>Registration Authority</h3>
            <p>
              Only the top four positions of the society (President, Vice President, Secretary, Treasurer) or the Teacher-in-Charge may proceed with the registration process.
            </p>
            <p style={{ marginTop: '10px', fontSize: '0.9em', color: '#ff4444' }}>
              Submissions from other members will be automatically disregarded.
            </p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <FaHeart />
            </div>
            <h3>Voting System</h3>
            <p>Winner determined by total points across platforms:</p>
            <ul>
              <li><FaWhatsapp style={{ color: '#25D366' }} /> WhatsApp Reaction – 5 pts</li>
              <li><FaInstagram style={{ color: '#E4405F' }} /> Instagram Like – 5 pts</li>
              <li><FaInstagram style={{ color: '#E4405F' }} /> Instagram Share – 10 pts</li>
              <li><FaInstagram style={{ color: '#E4405F' }} /> Instagram Repost – 15 pts</li>
              <li><FaFacebook style={{ color: '#1877F2' }} /> Facebook Like – 5 pts</li>
            </ul>
          </div>
        </div>

        <div className="details-section">
          <h2>How It Works</h2>
          
          <div className="highlight-box">
            <h3><FaBullhorn className="list-icon" /> Post Publication</h3>
            <p>
              After registration, a dedicated post for each participating school will be published on the Royal College Computer Society WhatsApp channel, Instagram, and Facebook page. Posts will include the school name, society details, and any creative content submitted during registration.
            </p>
          </div>

          <div className="highlight-box">
            <h3><FaHeart className="list-icon" /> Voting Process</h3>
            <p>
              Voting will be conducted through multiple social media platforms to ensure wider engagement and visibility. Each school's post will be shared across WhatsApp, Instagram, and Facebook.
            </p>
            <p style={{ marginTop: '10px' }}>
              Voting will begin immediately after the posts are published. The voting window will remain open for a pre-determined duration, which will be communicated at the time of post publication.
            </p>
          </div>

          <div className="highlight-box">
            <h3><FaTrophy className="list-icon" /> Winner Selection</h3>
            <p>
              The school whose post receives the highest cumulative points from all platforms by the voting deadline will be declared as the winner of the Most Popular ICT Society award.
            </p>
          </div>

          <div className="note-box" style={{ backgroundColor: '#ff444420', borderColor: '#ff4444' }}>
            <strong>⚠️ Important Rules:</strong>
            <ul style={{ marginTop: '10px' }}>
              <li>Any attempt to artificially inflate reactions, use bots, or manipulate votes will lead to immediate disqualification.</li>
              <li>Only reactions received within the voting period will be counted.</li>
              <li>The decision of the organizing committee will be final and binding.</li>
            </ul>
          </div>
        </div>

        <div className="action-section">
          <button 
            className="register-button"
            onClick={() => setShowForm(true)}
          >
            Register Your Society Now
          </button>
          <p className="action-note">
            Don't miss this opportunity to showcase your society's excellence!
          </p>
        </div>
      </div>

      {/* Overlay Form */}
      {showForm && (
        <div className="ict-form-overlay">
          <ICTSocietyForm
            competition={{ title: "Most Popular ICT Society" }}
            onClose={() => setShowForm(false)}
          />
        </div>
      )}
    </div>
    
  );
}
